import moment from 'moment';
import { toast } from 'react-toastify';
import { convertMilsToMm } from '../../../util/helperFunctions';
import { azureFetch } from '../../../api/azureFetch';
import { fetchSensorAlert } from '../../../api/sensorApi';


export const submitForm = (sensorID, startDate, endDate, setAlertReport, setLoading) => {
    setLoading(true);
    startDate = moment(startDate).format("YYYY-MM-DD");
    endDate = moment(endDate).format("YYYY-MM-DD");
    fetchSensorAlert(sensorID, startDate, endDate)
                .then((data) => {
                    setAlertReport(data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error(error);
                    setLoading(false);
                    toast.error("Error fetching alerts");
                });
};

export const updateThreshold = (sensorID, alertThreshold, units, setAlertReport, setLoading, setAlertThresholdUpdate) => {
    setLoading(true);
    setAlertReport(null);
    const startDate = moment("2016-01-01").format("YYYY-MM-DD");
    const setThreshold = units ? +convertMilsToMm(alertThreshold) : alertThreshold;

    azureFetch("update_threshold_and_createalerts", {
        sensor_id: sensorID,
        threshold: setThreshold,
        startDate: startDate,
        endDate: moment().format("YYYY-MM-DD")
    }).then((data) => {
        console.log("update_threshold_and_createalerts response:", data);
        if (data) {
            setAlertThresholdUpdate(alertThreshold);
        }
        setLoading(false);
    }).catch((error) => {
        console.error(error);
        setLoading(false);
        toast.error("Error updating threshold");
    });
};